import { TenantPackageConfig } from '~/tenants/common/registry';
import TwtPhotoConfig from '~/tenants/twt/performable/photo/TwtPhotoConfig';
import { TwtOrderContext, TwtPropertyType } from '~/tenants/twt/model/TwtOrder';
import TwtFloorplanConfig from '~/tenants/twt/performable/floorplan/TwtFloorplanConfig';
import { TwtOrderType } from '~/tenants/twt/model/enums';
import TwtNucleusConfig from '~/tenants/twt/performable/nucleus/TwtNucleusConfig';

const TwtNucleusTourConfig: TenantPackageConfig = {
  id: 'nucleus',
  name: 'Photos + Floor Plan + 3D Nucleus Tour',
  description:
    'An immersive 3D walkthrough that lets buyers explore the property anytime, from any device — no scheduling required.',
  performables: [TwtPhotoConfig, TwtNucleusConfig, TwtFloorplanConfig],
  eligible: (context) =>
    (context as TwtOrderContext).metadata.type === TwtOrderType.FOR_SALE_LISTING &&
    (context as TwtOrderContext).metadata.subtype !== TwtPropertyType.LAND,
};

export default TwtNucleusTourConfig;
